import { Component, Input, ViewChild, AfterViewInit, OnChanges, SimpleChanges,Output, EventEmitter, inject  } from '@angular/core';
import { HttpClient, HttpParams, provideHttpClient } from '@angular/common/http';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { catchError, map, startWith, switchMap } from 'rxjs/operators';
import { merge, of as observableOf } from 'rxjs';
import { Apiv1Service } from '../../../../services/apiv1.service';
import { NgFor,NgIf } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';

interface ColumnSorter {
  column_path: string;
  sorting_direction: string;
}

interface MultiSorter {
  column_sorters?: ColumnSorter[];
}

interface FilterColumn {
  ColumnPath: string;
  Operator: string;
  Operand: string;
}

interface FilterCanonical {
  Operator: string;
  Filters?: FilterColumn[];
}

interface Paging {
  page_number: number;
  lines_per_page: number;
}


export  interface ColumnOptions {
  link?: string;
  linkPostfixValueStoreKey?: string;
  valueTransformFunction?: (x:string) => string;
}



export  interface ColumnDef {
  title: string;
  store_key: string;
  options?: ColumnOptions;
}


@Component({
  selector: 'app-tablepaged',
  standalone: true,
  imports: [
    NgFor,        // ✅ required for *ngFor
 //   NgIf,         // optional but usually needed
   MatTableModule,
    MatPaginatorModule,
    MatSortModule
  ],
  templateUrl: './tablepaged.component.html',
  styleUrl: './tablepaged.component.scss'
})





export class TablepagedComponent implements AfterViewInit {

@Input() columns : Record<string, ColumnDef> = {
  id:               { title: 'Id',               store_key: 'Id' },
  idUserCreation:   { title: 'IdUserCreation',   store_key: 'IdUserCreation' },
  name:             { title: 'Name',             store_key: 'Name' },
  description:      { title: 'Description',      store_key: 'Description' }
};
@Output() delete = new EventEmitter<any>();  // emit row you want to delete
@Output() update = new EventEmitter<any>();  // emit row you want to delete
//displayedColumns = Object.keys(this.columns);


onDelete(row: any) {
  console.log("want to delete "+ JSON.stringify(row));
  this.delete.emit(row);
}

onUpdate(row: any) {
  console.log("want to update "+ JSON.stringify(row));

  this.update.emit(row);
}
  displayedColumns: (keyof typeof this.columns)[] = [];//string[];// = ['id', 'name', 'description', 'creation'];
  dataSource = new MatTableDataSource<any>();

  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;

  sorter: MultiSorter | null = null;
  filter: FilterCanonical | null = null;
  paging: Paging = { page_number: 0, lines_per_page: 10 };

  router: Router= inject(Router);
  route: ActivatedRoute = inject(ActivatedRoute);

  @Input() path: string = "";
  @Input() delete_button=true;
  @Input() update_button=true;



  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(private http: HttpClient, private store: Apiv1Service) {
    //this.displayedColumns = Object.keys(this.columns);
//this.displayedColumns = Object.keys(this.columns) as (keyof typeof this.columns)[];

  }

reload() {
  console.log("Refreshing table...");
  this.ngAfterViewInit();
  //this.getData(this.path);
}


getLink( row: any, col :ColumnDef, con :Record<string, ColumnDef>): string| undefined{
  
  var link: string| undefined;

  if ( col.options !== undefined ){

    if ( col.options?.link !== undefined ){
      link=col.options?.link;
    }
    else
    {
      link = this.router.url.substring(1);
      console.log("TablepagedComponent::getLink(): link ["+link+"].");
    }
    if ( col.options?.linkPostfixValueStoreKey !== undefined ){
      link += '/' + this.getByPath(row, con[col.options?.linkPostfixValueStoreKey].store_key);
    }
  }
 
  return link;
}

ngOnChanges(changes: SimpleChanges) {
    if (changes['columns']) {
      if (this.columns !== undefined)
      {
      this.displayedColumns = Object.keys(this.columns) as (keyof typeof this.columns)[];
      if(this.update_button) 
        if (!this.displayedColumns.includes('button_update'))
          this.displayedColumns.push('button_update');
       if(this.delete_button) 
        if (!this.displayedColumns.includes('button_delete'))
          this.displayedColumns.push('button_delete');
      }
    }
  }
  getByPath(obj: any, path: string) {
  return path.split('.').reduce((o, key) => o?.[key], obj);
}
  ngAfterViewInit(): void {
    this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
    if(this.path.length > 0)
    {
    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          return this.getData(this.path);
        }),
        map(data => {
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.resultsLength = data.totalCount;
          return data.items;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          this.isRateLimitReached = true;
          return observableOf([]);
        })
      )
      .subscribe(data => (this.dataSource.data = data));
    }
  }

  private getData( path: string) {
    this.sorter = {
      column_sorters: this.sort.active && this.sort.direction
        ? [
            {
              column_path: this.columns[ this.sort.active ].store_key,
              sorting_direction: this.sort.direction.toLowerCase()
            }
          ]
        : []
    };

    this.paging = {
      page_number: this.paginator.pageIndex,
      lines_per_page: this.paginator.pageSize
    };

    let params = new HttpParams()
      .set('paging', JSON.stringify(this.paging));

    if (this.sorter?.column_sorters?.length) {
      params = params
        .set('sorter', JSON.stringify(this.sorter));
    }

    if (this.filter?.Filters?.length) {
      this.filter.Filters.forEach((f, i) => {
        params = params
          .set('filter', JSON.stringify(this.filter));
      });
    }


    const getAll$ = this.store.getAllForPath(path, params);
    const count$ = this.store.getCountForPath(path, params);
    return getAll$.pipe(
      switchMap(items =>
        count$.pipe(map(totalCount => ({ items, totalCount })))
      )
    );
  }
}
